import CrudApiClient from './crudapiclient';
import { GATEWAY_API_URL } from '@admin-panel/config/env';
import { CrudFilters, CrudSort, MetaQuery } from '@refinedev/core';
import { axiosInstance } from './axios';

class CoyuCreditApiClient extends CrudApiClient {
  constructor() {
    super(GATEWAY_API_URL + '/coyucredit');
  }

  async history(
    sorters: CrudSort[],
    filters: CrudFilters,
    payload: any,
    query: any,
    headers: any,
    meta: MetaQuery | undefined,
  ): Promise<any> {
    try {
      if (!meta?.customerId) {
        return {
          data: [],
          total: 0,
        };
      }

      const currentPage =
        typeof meta?.currentPage === 'number' && meta.currentPage >= 1 ? meta.currentPage : 1;
      const size = typeof meta?.pageSize === 'number' && meta.pageSize > 0 ? meta.pageSize : 20;

      const params = new URLSearchParams();
      params.append('page', `${currentPage}`);
      params.append('size', `${size}`);

      const url = `${this.baseURL}/${meta.customerId}/history?${params.toString()}`;
      const response = await axiosInstance.post(url);
      const payload = response.data?.data;
      const content = Array.isArray(payload?.content)
        ? payload.content
        : Array.isArray(payload)
          ? payload
          : [];
      const totalElements =
        typeof payload?.totalElements === 'number' ? payload.totalElements : undefined;

      return {
        data: content,
        total: typeof totalElements === 'number' ? totalElements : content.length,
        pagination: {
          currentPage,
          pageSize: size,
        },
      };
    } catch (error) {
      throw error;
    }
  }
}

export default CoyuCreditApiClient;
